import React, { Component } from "react";

export default class TextBox extends Component {
  render() {
    return (
      <div className="col-sm-10">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #dddddd",
            borderRadius: "4px",
            padding: "10px 12px 10px 12px",
            height: 35,
          }}
        >
          <div
            style={{
              fontSize: 14,
            }}
          >
            {this.props.text}
          </div>
        </div>
      </div>
    );
  }
}
